import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ContactService } from '@services/contact.service';
import { EmailCreateTabManagerService } from '@services/email-create-tab-manager.service';
import { EmailSendingService } from '@services/email-sending.service';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import Hashids from 'hashids';
import { TranslateService } from '@ngx-translate/core';
import { ContactsListComponent } from 'src/app/views/contacts/contacts-list/contacts-list.component';
import { ContactsGroupsComponent } from 'src/app/views/contacts/groups/groups.component';

@Component({
  selector: 'wsb-email-create-recipients',
  templateUrl: './email-create-recipients.component.html',
  styleUrls: ['./email-create-recipients.component.scss'],
  standalone: false
})
export class EmailCreateRecipientsComponent implements OnInit, OnDestroy {
  @ViewChild('contactsListComponent') contactsListComponent: ContactsListComponent;
  @ViewChild('groupListComponent') groupListComponent: ContactsGroupsComponent;
  @ViewChild('modalConfirmNavigation') modalConfirmNavigation;
  modalConfirmNavigationModal: NgbModalRef;

  @Input() emailCampaignIssue;

  apiGetContactsOptions;
  activeId = 1;
  hashids;
  listenerNext: Subscription;
  listenerBack: Subscription;

  constructor(
    private contactService: ContactService,
    private emailSendingService: EmailSendingService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private emailCreateTabManagerService: EmailCreateTabManagerService
  ) {}

  ngOnInit(): void {
    this.listenToNextButton();
    this.listenToBackButton();
  }

  enableButton() {
    return this.contactService.selectedList.size > 0;
  }

  listenToNextButton() {
    this.listenerNext = this.emailCreateTabManagerService.lgNext$.subscribe(tab => {
      if (tab === 4) {
        this.next();
      }
    });
  }

  listenToBackButton() {
    this.listenerBack = this.emailCreateTabManagerService.lgBack$.subscribe(tab => {
      if (tab === 4) {
        this.openNavigationConfemationModal();
      }
    });
  }

  next() {
    let obs$ = null;

    if (this.activeId === 1) {
      if (this.groupListComponent.grid.isSelectedAll()) {
        obs$ = this.emailSendingService.assignGroup(this.emailCampaignIssue.idCampaignIssue, [], 'SELECT_ALL');
      } else {
        this.groupListComponent.grid
          .getSelectedList()
          .pipe(
            map((data: any[]) => {
              const newData = data.map(item => item.id);
              return newData;
            })
          )
          .subscribe(list => {
            obs$ = this.emailSendingService.assignGroup(this.emailCampaignIssue.idCampaignIssue, list, 'SELECT_BY_IDS');
          });
      }
    } else {
      if (this.contactsListComponent) {
        if (this.contactsListComponent.grid.isSelectedAll()) {
          this.apiGetContactsOptions = this.contactsListComponent.getApiGetContactsOptions();
          obs$ = this.emailSendingService.assignContact(this.emailCampaignIssue.idCampaignIssue, [], this.apiGetContactsOptions);
        } else {
          this.contactsListComponent.grid.getSelectedList().subscribe((contacts: any[]) => {
            const contactsIds = contacts.map(contact => contact.idContact);
            obs$ = this.emailSendingService.assignContact(this.emailCampaignIssue.idCampaignIssue, contactsIds, null);
          });
        }
      }
    }

    this.emailCreateTabManagerService.setTabIsReady(obs$);
    this.emailCreateTabManagerService.lgDone();
  }

  goToEditor() {
    this.createHashIds();
    window.location.href = '/mail/mail-editor?issue=' + this.hashids.encode(this.emailCampaignIssue.idCampaignIssue) + '&new_version=true';
  }

  createHashIds() {
    this.translateService.get('pages_salt_hashids').subscribe(salt => {
      this.hashids = new Hashids(salt, 26, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890');
    });
  }

  openNavigationConfemationModal() {
    this.modalConfirmNavigationModal = this.modalService.open(this.modalConfirmNavigation);

    this.modalConfirmNavigationModal.result.then(
      result => {},
      reason => {}
    );
  }

  ngOnDestroy(): void {
    this.listenerNext.unsubscribe();
    this.listenerBack.unsubscribe();
  }
}
